export default {
    changelogOpen: false,
    logs: [],
    creationModal: {
        isOpen: false,
        data: {
            name: '',
            enabled: true,
        },
        errors: {},
    },
    errors: {},
    testSubjectsList: [],
}
